var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z","key":0}),React.createElement("path",{"d":"M0-.75h24v24H0z","fill":"none","key":1})]);
}

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;
